export default "__VITE_ASSET__BPMPbpSE__"